import {
  DataSnapshot,
  increment,
  onValue,
  ref,
  update
} from 'firebase/database'

import { database } from '@/ui/config/firebase'

import { UnreadCountsEnum } from '../domain/models/UnreadCountsEnum'
import { UnreadCountDatasourceAdapter } from '../infra/datasources/UnreadCountDatasource'

export const UnreadCountDatasource: UnreadCountDatasourceAdapter = {
  getUnreadCount(params: {
    profileId: string
    countPath: UnreadCountsEnum
    onValue: (snapshot: DataSnapshot) => unknown
  }) {
    const userChatNotificationsCount = ref(
      database,
      `unreadCounts/${params.profileId}/${params.countPath}`
    )

    return onValue(userChatNotificationsCount, params.onValue)
  },

  async reduceUnreadCount(params: {
    profileId: string
    countPath: UnreadCountsEnum
    reduceBy?: number
  }) {
    const userChatNotificationsCount = ref(
      database,
      `unreadCounts/${params.profileId}`
    )

    const countPath = params.countPath
    const reduceBy = params.reduceBy ?? 1

    await update(userChatNotificationsCount, {
      [countPath]: increment(reduceBy * -1)
    })
  }
}
